var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m14.069 12.326 3.087 3.086a1.008 1.008 0 0 1-.019 1.448 1.008 1.008 0 0 1-1.43 0l-3.209-3.21a7.304 7.304 0 1 1 1.57-1.324zM8.625 2.21A5.258 5.258 0 0 0 3.364 7.46a5.273 5.273 0 0 0 5.267 5.267A5.258 5.258 0 0 0 8.625 2.21z","fill":"#502314"}));
}

Search.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Search;

Search.default = Search;
